import React, { Component } from 'react';
import sortIcon from '../../../../../assets/img/vrms-sort-table-column.svg';

class SortableTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sortKey: 'uploadDate',
      sortDir: 'desc',
      currentPage: 1,
      itemsPerPage: 10
    };
  }

  handleSort = (key) => {
    this.setState((prevState) => ({
      sortKey: key,
      sortDir: prevState.sortKey === key && prevState.sortDir === 'desc' ? 'asc' : 'desc'
    }));
  };

  sortData = function(data) {
    const { sortKey, sortDir } = this.state;
    const dir = sortDir === 'asc' ? 1 : -1;

    const items = Array.isArray(data) ? data.slice() : [];

    return items.sort((a, b) => {
      let va = a[sortKey];
      let vb = b[sortKey];

      if (sortKey === 'uploadDate') {
        va = new Date(va).getTime() || 0;
        vb = new Date(vb).getTime() || 0;
      }

      if (va < vb) return -dir;
      if (va > vb) return dir;
      return 0;
    });
  };

  changePage = (page) => {
    this.setState({ currentPage: page });
  };

  render() {
    const { data = [] } = this.props;
    const { sortKey, sortDir, currentPage, itemsPerPage } = this.state;

    const sorted = this.sortData(data);
    const totalPages = Math.ceil(sorted.length / itemsPerPage);
    const start = (currentPage - 1) * itemsPerPage;
    const paginated = sorted.slice(start, start + itemsPerPage);

    const headers = [
      { key: 'documentName', label: 'Document Name' },
      { key: 'uploadedBy', label: 'Uploaded By' },
      { key: 'importType', label: 'Import Type' },
      { key: 'uploadDate', label: 'Upload Date' },
      { key: 'status', label: 'Status' },
      { key: 'logFiles', label: 'Log' }
    ];

    return (
      <div className="sortable-table-container">
        <div className="table-wrapper">
          <table className="sortable-table">
            <thead className="table-head">
              <tr>
                {headers.map((h) => {
                  const isActive = sortKey === h.key;
                  const isInitialUpload = h.key === 'uploadDate' && sortKey === 'uploadDate';
                  const direction = isActive ? sortDir : (isInitialUpload ? 'desc' : 'asc');

                  return (
                    <th
                      key={h.key}
                      className="table-th"
                      onClick={() => this.handleSort(h.key)}
                    >
                      {h.label}
                      <img
                        src={sortIcon}
                        alt="sort"
                        width="14"
                        height="14"
                        className="sort-icon"
                        style={{
                          transform: direction === 'asc' ? 'rotate(180deg)' : 'none',
                          opacity: isActive ? 1 : 0.4
                        }}
                      />
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody className="table-body">
              {paginated.length === 0 ? (
                <tr>
                  <td colSpan={6} className="no-data">
                    No data found
                  </td>
                </tr>
              ) : (
                paginated.map((row, i) => {
                  // Find the import type log file for downloadable document link
                  const importLogFile = (row.logFiles || []).find(log => log.type === 'import');
                  const documentDownloadUrl = importLogFile ? importLogFile.downloadUrl : row.documentLink;
                  const documentFileName = importLogFile ? importLogFile.fileName : null;
                  const filteredLogFiles = (row.logFiles || []).filter(log => log.type !== 'import');

                  return (
                    <tr key={i} className="table-row">
                      <td className="table-td document-name">
                        <a href={documentDownloadUrl || '#'} target="_blank" rel="noopener noreferrer" className="doc-link" download={documentFileName}>
                          {row.documentName || '—'}
                        </a>
                      </td>
                      <td className="table-td">{row.uploadedBy || '—'}</td>
                      <td className="table-td">{row.importType || '—'}</td>
                      <td className="table-td">
                        {row.uploadDate ? new Date(row.uploadDate).toLocaleDateString('en-US') : '—'}
                      </td>
                      <td className="table-td">{row.status || '—'}</td>
                      <td className="table-td log-cell">
                        {filteredLogFiles.length > 0 ? (
                          <div className="log-links">
                            {filteredLogFiles.map((log, idx) => {
                              const label = log.type === 'success'
                                ? `Success (${log.recordCount})`
                                : log.type === 'error'
                                  ? `Error (${log.recordCount})`
                                  : `Import (${log.recordCount})`;

                              const typeClass = log.type === 'success'
                                ? 'success'
                                : log.type === 'error'
                                  ? 'error'
                                  : 'import';

                              return (
                                <React.Fragment key={idx}>
                                  <a
                                    href={log.downloadUrl || '#'}
                                    download={log.fileName}
                                    className={`log-link ${typeClass}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    {label}
                                  </a>
                                  {idx < filteredLogFiles.length - 1 && ', '}
                                </React.Fragment>
                              );
                            })}
                          </div>
                        ) : (
                          <span className="no-logs">—</span>
                        )}
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>

        {totalPages > 1 && (
          <div className="pagination">
            <button
              className="page-btn"
              disabled={currentPage === 1}
              onClick={() => currentPage > 1 && this.changePage(currentPage - 1)}
            >
              Prev
            </button>

            {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
              <button
                key={page}
                className={`page-btn ${page === currentPage ? 'active' : ''}`}
                onClick={() => this.changePage(page)}
              >
                {page}
              </button>
            ))}

            <button
              className="page-btn"
              disabled={currentPage === totalPages}
              onClick={() => currentPage < totalPages && this.changePage(currentPage + 1)}
            >
              Next
            </button>
          </div>
        )}
      </div>
    );
  }
}

export default SortableTable;
